import { useDayjs } from '@/composables';

const formatShortDate = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).format('DD MMM YYYY');
};

const formatShortDateAndTime = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).format('DD MMM YYYY [at] HH:mm A');
};

const formatFromNow = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).fromNow();
};

export const useDateFormatter = () => {
  return {
    formatShortDate,
    formatFromNow,
    formatShortDateAndTime,
  };
};
